import gql from 'graphql-tag';
import { DocumentsFragments } from './documents.fragments';

export class DocumentsQueries {
  static getMany = gql`
    query Documents(
      $documentFilter: DocumentFilter!
      $userIds: [String!]
      $orderBy: String
      $limit: Int
      $offset: Int
      $tagIds: [String!]
      $withoutTags: Boolean
      $nameSearch: String
    ) {
      getDocuments(
        documentFilter: $documentFilter
        userIds: $userIds
        orderBy: $orderBy
        limit: $limit
        offset: $offset
        tagIds: $tagIds
        withoutTags: $withoutTags
        nameSearch: $nameSearch
      ) {
        ...documentsListFragment
      }
    }
    ${DocumentsFragments.documentsListFragment}
  `;

  static getDocumentPage = gql`
    query DocumentPage($documentId: String!, $id: String!) {
      documentPage(documentId: $documentId, id: $id) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
      }
    }
  `;
}
